import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { PaymentsService } from '../../core/services/payments.service';
import { Subscription, interval } from 'rxjs';
import { MerchantsService } from '../../core/services/merchants.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpModalComponent } from '../../shared/modals/help-modal/help-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PlansModalComponent } from '../../shared/modals/plans-modal/plans-modal.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { isPlatformBrowser } from '@angular/common';
import { AnalyticsService } from '../../core/services/analytics.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-mbway-renew',
  templateUrl: './mbway-renew.component.html',
  styleUrls: ['./mbway-renew.component.scss'],
})
export class MbwayRenewComponent implements OnInit {
  public loading = true;
  public form: FormGroup;

  public merchantSlug;

  public merchantSubscription: Subscription;
  public paymentIntervalSubscription: Subscription;
  public paymentInfo;
  public paymentInfoError = false;
  public mbwayError = false;
  public waitingForMbwayPayment = false;
  public paymentSuccess = false;

  public submitAttempted = false;

  public isLoggedIn = false;

  public processingPayment = false;
  public saving = false;

  public bsModalRef;

  constructor(
    private paymentsService: PaymentsService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) protected platformId,
    private modalService: BsModalService,
    private merchantService: MerchantsService,
    private analytics: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.merchantSlug = this.activatedRoute.snapshot.params.id;

    // check if user is logged in
    if (isPlatformBrowser(this.platformId) && localStorage?.getItem('currentUser')) {
      this.isLoggedIn = true;
    }

    this.getSubscriptionRenewInfo();
    let defaultPhoneNumber = this.activatedRoute.snapshot.queryParams.ph;
    if (defaultPhoneNumber && Number(defaultPhoneNumber)) {
      defaultPhoneNumber = defaultPhoneNumber.replace(/\D/g, '+');
    } else {
      defaultPhoneNumber = '';
    }
    this.generateForm(defaultPhoneNumber);

  }

  getSubscriptionRenewInfo() {
    this.paymentsService.getPendingSubscriptionRenewInfo(this.merchantSlug).subscribe(
      (res) => {
        this.paymentInfo = res;
        this.loading = false;
      },
      (err) => {
        this.paymentInfoError = true;
        this.loading = false;
      }
    );
  }

  generateForm(defaultPhoneNumber = '') {
    this.form = this.fb.group({
      phoneNumber: [defaultPhoneNumber, [Validators.required]],
    });
  }

  processPayment() {
    this.analytics.trackProductAnalyticsEvent('payMbwayRenewModal', { merchantSlug: this.merchantSlug });

    this.submitAttempted = true;
    this.mbwayError = false;

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    this.paymentsService.sendMbWayRenewIntent(this.merchantSlug, this.form.value.phoneNumber).subscribe(
      (res) => {
        this.processingPayment = true;
        this.saving = false;
        if (res?.mbwayPaymentRequestSent) {
          this.waitForMbwayPayment()
        } else {
          this.mbwayError = true;
        }
      },
      (err) => {
        this.saving = false;
        this.mbwayError = true;
      }
    );
  }

  waitForMbwayPayment() {
    this.waitingForMbwayPayment = true;
    this.paymentIntervalSubscription = interval(1000 * 5).subscribe(() => {
      this.paymentsService.getPendingSubscriptionRenewInfo(this.merchantSlug).subscribe(
        (res) => {
          if (res?.status === 'active') {
            this.paymentSuccess = true;
            this.waitingForMbwayPayment = false;
            this.paymentIntervalSubscription.unsubscribe();

            if (this.isLoggedIn) {
              this.merchantService.getMerchant().subscribe();
            }
          }
        }
      );
    });
  }

  showHelpModal() {
    this.bsModalRef = this.modalService.show(HelpModalComponent, { class: 'modal-md' });
  }

  openPlansModal() {
    this.bsModalRef = this.modalService.show(PlansModalComponent, { class: 'modal-md' });
  }
}
